module.exports = __webpack_public_path__ + "static/media/fvs_valve1_31.a9492893.jpg";